var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-view"},[_c('div',{staticClass:"home-view__action"},[_c('SimpleButton',{attrs:{"title":_vm.introSettings.button_label,"to":_vm.testRoute,"large":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }